type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

/** Reels glyph: rounded square with a clapper band and a play triangle. */
const ReelIcon = (props: Props) => {
  const { width = '14', height = '14', strokeColor = 'currentColor' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <line x1="2" y1="7.5" x2="22" y2="7.5" />
      <line x1="8" y1="2.5" x2="10.5" y2="7.5" />
      <line x1="15" y1="2.5" x2="17.5" y2="7.5" />
      <path d="m10.2 11.6 4.8 2.9-4.8 2.9z" />
    </svg>
  );
};

export default ReelIcon;
